import ActionBar from '@/Components/UI/ActionBar'

interface Props {
  editMode: boolean
  onEditDetails: () => void
  onCancelEdit: () => void
  onSaveEdits: () => void
  onSubmit: () => void
  isSubmitting?: boolean
  submitLabel?: string
}

const SummaryPageActionBar = ({
  editMode,
  onEditDetails,
  onCancelEdit,
  onSaveEdits,
  onSubmit,
  isSubmitting,
  submitLabel = 'Submit event',
}: Props) =>
  editMode ? (
    <ActionBar
      primaryLabel='Save edits'
      onPrimary={onSaveEdits}
      secondaryLabel='Cancel'
      onSecondary={onCancelEdit}
      primaryWide
    />
  ) : (
    <ActionBar
      primaryLabel={submitLabel}
      onPrimary={onSubmit}
      primaryDisabled={isSubmitting}
      secondaryLabel='Edit details'
      onSecondary={onEditDetails}
      primaryWide
    />
  )

export default SummaryPageActionBar
